export enum EContextMenuTargetTypes {
	Container = 'Container',
	Row = 'Row',
	Column = 'Column'
}
